import { CommandsBase } from './base';

export namespace Users {
  export namespace Types {
    export interface User {
      email: string;
      groups: string[];
    }

    export type FindRequest = {
      email: string;
    };
    export type ListRequest = Record<string, unknown>;
    export type ListResponse = User[];
  }

  export const SERVICE = 'users';
  export const ACTIONS = {
    list: 'list',
    find: 'find',
  };
  export const EVENTS = {};

  export class Commands extends CommandsBase {
    getUser(props: Types.FindRequest) {
      return this.findByEmail(props).then((users) => {
        if (users && users.length > 1) {
          throw new Error(`Found not 1 user, but ${users.length}`);
        }

        return users.length ? users[0] : null;
      });
    }

    findByEmail(props: Types.FindRequest) {
      return this.client.execute<Types.FindRequest, Types.ListResponse>(
        this.command(ACTIONS.find),
        props
      );
    }

    list() {
      return this.client.execute<Types.ListRequest, Types.ListResponse>(
        this.command(ACTIONS.list),
        {}
      );
    }
  }
}
